import { useLocation } from 'react-router-dom';
import { SECTION_NAMES } from '@constants/sectionNames';
import { createReportLink } from '../utils/createReportLink';
export const useReportLink = (reportId) => {
    const location = useLocation();
    return createReportLink({ label: SECTION_NAMES.analytics, location })(reportId);
};
